import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { AntecedentesEnum } from 'src/app/enums/antecedentes';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { environment } from '../../../../environments/environment';
import { Country, FiltratedObjetives, DatosBancario, Antecedente, AntecedentesMarcas } from '../../../api/interfaces/register';
import { Contact, Personal, Physiological, Training,  PersonalTrainer, UserComplete, AllAchievements, Level, EntrenamientoModelBroken, MotivoBaja } from '../../../api/interfaces/user';
import { UserService } from '../../../api/services/user/user.service';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';
import { SnackbarService } from '../../../utils/snackbar/snackbar.service';
import { Subscription } from 'rxjs';
import { HoursDayFixedService } from 'src/app/utils/hoursDayFixed/hours-day-fixed.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  disableSave: boolean = true;
  isMetasObjetivos: boolean = false;
  isMobile: boolean = false;
  loaded: boolean = false;
  @Input('id') id: number;
  @Input('isAdmin') isAdmin: boolean;
  @Input('isStudent') isStudent: boolean;

  avatarUrl: string = null;
  estado: string = "";

  profile: UserComplete;
  personalData: Personal;
  country: Country;
  physiologicalData: Physiological;
  contactData: Contact;
  personalTrainer: PersonalTrainer;
  level: Level;
  training: Training;
  alumnosDatosBancario: DatosBancario = {
    claveBancaria: "",
    entidad: ""
  };
  allAchievements: AllAchievements = {
    route: null,
    pista: null,
    ultra: null,
    trail: null
  };
  antecedente: Antecedente[];
  antecedentesMarcas: AntecedentesMarcas[] = [];
  datosTraining: EntrenamientoModelBroken = {
    grupo: "",
    entrenamientoTipo: "",
    idGrupo: -1
  };

  objetives: FiltratedObjetives[] = [];

  usuarioId: number = 0;

  motivoBaja: MotivoBaja;

  private sharedData$: Subscription;

  constructor(
    private userService: UserService,
    private snack: SnackbarService,
    private mobileDetectorService: MobileDetectorService,
    private router: ActivatedRoute,
    private registerService: RegisterService,
    private sharedData: SharedDataService,
    private routerRedirect: Router,
    private hoursDayFixed: HoursDayFixedService
  ) { }

  ngOnInit(): void {
    const url = this.router.snapshot.routeConfig.path;
    if(url == "alumno/metas-objetivos") {
      this.isMetasObjetivos = true;
    }
    this.isMobile = this.mobileDetectorService.isMobile();
    this.getData();
    this.sharedData$ = this.sharedData.currentMessage.subscribe(message => {

      if(message =="saveObjetives") {
        //bugfix date
        this.objetives.forEach(objetivo =>  {
          let auxDate = objetivo.fechaObjetivo;
          const auxDate2: string [] = auxDate.split('T');
          objetivo.fechaObjetivo = auxDate2[0] + "T12:00:00.000+00:00";
        });
        this.profile.objetivo = this.objetives;
        this.registerService.editObjetives(this.id, this.objetives).subscribe(response => {
          this.getData();
        },
          error => {
            console.error(error);
            this.snack.snackTranslate('snacks.error.generic');
          })
      }

      if(message =="saveAchievements") {
        //bugfix date
        // this.allAchievements.pista.forEach(element => {
        //   let auxDate: string = new Date(element.fechaMarca).toISOString();
        //   const auxDate2: string [] = auxDate.split('T');
        //   element.fechaMarca = auxDate2[0] + "T12:00:00.000+00:00";
        // });

        // this.allAchievements.route.forEach(element => {
        //   let auxDate: string = new Date(element.fechaMarca).toISOString();
        //   const auxDate2: string [] = auxDate.split('T');
        //   element.fechaMarca = auxDate2[0] + "T12:00:00.000+00:00";
        // });

        // this.allAchievements.trail.forEach(element => {
        //   let auxDate: string = new Date(element.fechaMarca).toISOString();
        //   const auxDate2: string [] = auxDate.split('T');
        //   element.fechaMarca = auxDate2[0] + "T12:00:00.000+00:00";
        // });
        
        // this.allAchievements.ultra.forEach(element => {
        //   let auxDate: string = new Date(element.fechaMarca).toISOString();
        //   const auxDate2: string [] = auxDate.split('T');
        //   element.fechaMarca = auxDate2[0] + "T12:00:00.000+00:00";
        // });

        this.profile.antecedentesMarcas = [...this.allAchievements.pista, ...this.allAchievements.route, ...this.allAchievements.trail, ...this.allAchievements.ultra];
        this.registerService.editAchievements(this.id, this.profile.antecedentesMarcas).subscribe(response => {
          this.getData();
        },
          error => {
            console.error(error);
            this.snack.snackTranslate('snacks.error.generic');
          });
      }

      if(message =="updateStatus" || message == "reloadWeek2") {
        // this.profile.paisId = this.personalData.pais.id;
        this.getUserProfileData();
      }

      if( message == "reloadMail") {
        this.profile.email = sessionStorage.getItem('email');
        sessionStorage.removeItem('email');
      }
    })
  }

  getData() {
    if (this.id) {
      this.getUserProfileData();
    } else {
      this.getMyProfileData();
    }
  }

  getUserProfileData() {
    if(isNaN(this.id)) {
      this.routerRedirect.navigateByUrl('admin/alumnos');
    } else {

      this.userService.getProfileUserId(this.id).subscribe(response => {
        this.loadData(response);
        if (response.entrenador.entrenadorNombre == "NO DEFINIDO" || response.entrenamientoNivel.entrenamientoNivelDescripcion == "NO DEFINIDO") {
          this.disableSave = true;
        }
        if (response.entrenador.entrenadorNombre !== "NO DEFINIDO" && response.entrenamientoNivel.entrenamientoNivelDescripcion !== "NO DEFINIDO") {
          this.disableSave = false;
        }
      },
      error => {
        console.error(error);
        this.snack.snackTranslate('snacks.error.generic');
      })
    }
  }

  getMyProfileData() {
    this.id = parseInt(localStorage.getItem('idAlumno'),10);
    if(isNaN(this.id)) {
      this.routerRedirect.navigateByUrl('admin/alumnos');
    } else {

      this.userService.getProfileUserId(this.id).subscribe(response => {
        this.profile = response;
        this.loadData(response);
      },
      error => {
        console.error(error);
        this.snack.snackTranslate('snacks.error.generic');
      })
    }
  }


  //assing data to objects
  loadData(response: UserComplete) {
    this.motivoBaja = response.usuario.motivoBaja;
    this.profile = response;
    this.estado = response.estado;
    this.usuarioId = response.usuarioId,
    sessionStorage.setItem('estado',this.estado);

    this.personalData = {
      nombre: response.nombre,
      apellido: response.apellido,
      segundoApellido: response.segundoApellido,
      numeroDocumento: response.numeroDocumento,
      fechaNacimiento: response.fechaNacimiento,
      pais: response.pais,
      residencia: response.residencia,
      documentoTipo: response.documentoTipo,
    };

    this.physiologicalData = {
      altura: response.altura,
      peso: response.peso
    };

    this.contactData = {
      email: response.email,
      numeroCelular: response.numeroCelular,
      numeroEmergencia: response.numeroEmergencia,
      prefijoCelular: response.prefijoCelular,
      prefijoEmergencia: response.prefijoEmergencia,
    }

    let training = {
      entrenamientoTipo: response.entrenamientoTipo,
      grupo: response.grupo
    }

    this.training = {
      level: response.entrenamientoNivel,
      trainer: response.entrenador,
      type: training,
    }

    // requiered because backend model mappers broke...
    this.datosTraining = {
      grupo : response.entrenamientoGrupo.entrenamientoGrupoDescripcion,
      idGrupo: response.entrenamientoGrupo.id,
      entrenamientoTipo : response.entrenamientoTipo.entrenamientoCodigo,
    }

    //backend provide more information than necesary for alumnosDatosBancario
    if(response.alumnosDatosBancario[0]) {
      this.alumnosDatosBancario.claveBancaria = response.alumnosDatosBancario[0].claveBancaria;
      this.alumnosDatosBancario.entidad = response.alumnosDatosBancario[0].entidad;
      this.alumnosDatosBancario.alumnoId = response.alumnosDatosBancario[0].alumnoId;
      this.alumnosDatosBancario.arancel = response.alumnosDatosBancario[0].arancel;
      this.alumnosDatosBancario.id = response.alumnosDatosBancario[0].id
    }

    this.antecedente = response.antecedente;
    if(response.antecedentesMarcas) {
      let aux: AntecedentesMarcas[] = [];
      this.allAchievements.route = [];
      this.allAchievements.pista = [];
      this.allAchievements.ultra = [];
      this.allAchievements.trail = [];
      response.antecedentesMarcas.forEach( marca => {
        if(marca.fechaMarca) {
          marca.fechaMarca = this.hoursDayFixed.getDateFixed(marca.fechaMarca);
        }
      });

      aux =  response.antecedentesMarcas.filter(antecedente => antecedente.antecedentePreguntaDetalleId == AntecedentesEnum.RUTA);
      aux.forEach(achievement => {
        achievement.valid = true;
        if(achievement.activo) {
          this.allAchievements.route.push(achievement);
        }
      });

      aux =  response.antecedentesMarcas.filter(antecedente => antecedente.antecedentePreguntaDetalleId == AntecedentesEnum.PISTA);
      aux.forEach(achievement => {
        achievement.valid = true;
        if(achievement.activo) {
          this.allAchievements.pista.push(achievement);
        }
      });
      
      aux =  response.antecedentesMarcas.filter(antecedente => antecedente.antecedentePreguntaDetalleId == AntecedentesEnum.ULTRA);
      aux.forEach(achievement => {
        achievement.valid = true;
        if(achievement.activo) {
          this.allAchievements.ultra.push(achievement);
        }
      });
      
      aux =  response.antecedentesMarcas.filter(antecedente => antecedente.antecedentePreguntaDetalleId == AntecedentesEnum.TRAIL);
      aux.forEach(achievement => {
        achievement.valid = true;
        if(achievement.activo) {
          this.allAchievements.trail.push(achievement);
        }
      });
    }

    this.objetives = [];

    response.objetivo.sort(function (a, b) {
      var key1 = new Date(a.fechaObjetivo);
      var key2 = new Date(b.fechaObjetivo);
  
      if (key1 < key2) {
          return -1;
      } else if (key1 == key2) {
          return 0;
      } else {
          return 1;
      }
    });
    response.objetivo.forEach( objetivo => {
      
      if(objetivo.fechaObjetivo) {
        objetivo.fechaObjetivo = this.hoursDayFixed.getDateFixed(objetivo.fechaObjetivo);
      }
      //check expired
      if(objetivo.fechaObjetivo) {
        if(new Date(objetivo.fechaObjetivo).setHours(12) < new Date().setHours(11)) {
          objetivo.activo = false;
        }
      }
      //not else due to backend can send objetivo.activo = false
      if(objetivo.activo) {
        this.objetives.push(objetivo);
      }
    });
    
    this.objetives.forEach(objetivo => objetivo.valid = true);
    if (response.avatarUrl) {
      this.avatarUrl = environment.apiUrl + response.avatarUrl;
    } else {
      this.avatarUrl = null;
    }

    if(this.isStudent) {
      const nombreCompleto: string = `${response.nombre} ${response.apellido} ${response.segundoApellido ? response.segundoApellido : ''}`;
      localStorage.setItem("descripcionUsuario",nombreCompleto);
    }

    this.loaded = true;
  }

  editPersonal(auxPersonal: Personal) {
    this.profile.nombre = auxPersonal.nombre,
    this.profile.apellido = auxPersonal.apellido,
    this.profile.segundoApellido = auxPersonal.segundoApellido,
    this.profile.numeroDocumento = auxPersonal.numeroDocumento,
    this.profile.fechaNacimiento = auxPersonal.fechaNacimiento,
    this.profile.pais = auxPersonal.pais,
    this.profile.paisId = auxPersonal.pais.id,
    this.profile.residencia = auxPersonal.residencia,
    this.profile.documentoTipo = auxPersonal.documentoTipo;
    this.profile.documentoTipoId = auxPersonal.documentoTipo.id;
    this.updateProfile();
  }

  editPhysiological(auxPhysiological: Physiological) {
    this.profile.peso = auxPhysiological.peso,
    this.profile.altura = auxPhysiological.altura
    this.updateProfile();
  }

  editBank(auxBank: DatosBancario) {
    let bankData: DatosBancario [] = [];
    bankData.push(auxBank)
    this.registerService.editBankData(this.profile.id, bankData)
    .subscribe(response => {
      this.snack.snackTranslate('snacks.sucess.updatingData.generic');
    },
    error => {
        this.sharedData.changeMessage("updateBank");
        console.error(error);
        if(error.error && error.error.message) {
          this.snack.openSnackBar(error.error.message);
        } else {
          this.snack.snackTranslate('snacks.error.generic');
        }
      });
  }

  editContact(auxContact: Contact) {
    this.profile.email = auxContact.email,
    this.profile.numeroCelular = auxContact.numeroCelular,
    this.profile.prefijoCelular = auxContact.prefijoCelular,
    this.profile.numeroEmergencia = auxContact.numeroEmergencia,
    this.profile.prefijoEmergencia = auxContact.prefijoEmergencia
    this.updateProfile();
  }

  updateProfile() {
    this.registerService.editUserData(this.id, this.profile)
    .subscribe(response => {
        this.getData();
      },
      error => {
        console.error(error);
        this.snack.snackTranslate('snacks.error.generic');
      });
  }

  public ngOnDestroy(): void {
    this.sharedData$.unsubscribe();
  }

}
